// customerSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';


export const getCustomerProfileThunk = createAsyncThunk(
  'customer/getUserProfileThunk',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.getCustomerProfile(data);
      dispatch(setLoggedIn(true))
      // console.log("saaaaaaaaaaa",response.data);
      return response.data?.data;

    } catch (error) {
      console.log(error);
      /*   toast.error('something went wrong') */

    }
  }
);



export const upadteCustomerProfileThunk = createAsyncThunk(
  'customer/customerThunk',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.updateCustomerBasicDetails(data);
      dispatch(setCustomerRefresh())
      toast.success('Basic details updated successfully')
      return response.data?.data;
    } catch (error) {
      console.log(error);
      toast.error( error?.response?.data?.message ||'something went wrong')

    }
  }
);

export const upadteCustomerPassThunk = createAsyncThunk(
  'customer/customerPassThunk',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.updateCustomerPassword(data);
      toast.success('Password updated successfully');
      return response.data?.data;
    } catch (error) {
      console.log(error);
      toast.error('something went wrong')

    }
  }
);

export const addCBillingAddressThunk = createAsyncThunk(
  'customer/addBilling',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.addCustomerBillingAdress(data);
      dispatch(setCustomerRefresh())
      toast.success('Billing address added successfully')
      return response.status;
    } catch (error) {
      console.log(error);
      toast.error('something went wrong')

    }
  }
);

export const upadteBillingAddressThunk = createAsyncThunk(
  'customer/updateBilling',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.updateCustomerBilling(data);
      dispatch(setCustomerRefresh())
      toast.success('Billing address edited successfully')
      return response.status;
    } catch (error) {
      console.log(error);
      toast.error('something went wrong')
    }
  }
);


export const addCShippingAddressThunk = createAsyncThunk(
  'customer/addcShipping',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.addCustomerShippingAdress(data);
      dispatch(setCustomerRefresh())
      toast.success('Shipping address added successfully')
      return response.status;
    } catch (error) {
      console.log(error);
      toast.error('something went wrong')

    }
  }
);

export const upadteCShippingAddressThunk = createAsyncThunk(
  'customer/updtecshipping',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.updateCustomerShipping(data);
      dispatch(setCustomerRefresh())
      toast.success('Billing address edited successfully')
      return response.status;
    } catch (error) {
      console.log(error);
      toast.error('something went wrong')
    }
  }
);


// The multi-step registration keeps its draft in sessionStorage so a page refresh between
// the steps does not lose the name / email / password typed on the first step.
const DRAFT_KEY = 'ew_customer_regn_draft';
const readDraft = () => {
  try { return JSON.parse(sessionStorage.getItem(DRAFT_KEY) || '{}') || {}; } catch (e) { return {}; }
};
const writeDraft = (data) => {
  try {
    if (data && Object.keys(data).length) sessionStorage.setItem(DRAFT_KEY, JSON.stringify(data));
    else sessionStorage.removeItem(DRAFT_KEY);
  } catch (e) { /* storage unavailable: the draft just lives in memory */ }
};

const initialState = {
  customer: {},
  isLoggedin: false,
  loading: false,
  customerData: readDraft(),
  basicDetailsLoading: false,
  Passwordloading: false,
  refresh: false,
  alter: {
    data: {},
    loading: false
  },
  sameAddress: false,
  loginpopup:false
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerData: (state, action) => {
      state.customerData = { ...state.customerData, ...action.payload };
      writeDraft(state.customerData);
    },
    removeCustomerData: (state, action) => {
      state.customerData = {};
      writeDraft({});
    },
    setCustomerEditData: (state, action) => {
      state.alter.data = action.payload
    },
    setCustomerRefresh: (state, action) => {
      state.refresh = !state.refresh
    },
    setLoggedIn: (state, action) => {
      state.isLoggedin = action.payload
      if (action.payload === false) {
        state.customer = {}
      }
    },
    setAddress: (state, action) => {
      state.sameAddress = !state.sameAddress
    },
    setLoginpopup:(state,action)=>{
      state.loginpopup = action.payload
    },
    deleteCustomerdata:(state,action)=>{
      state.customerData = {}
      writeDraft({})
    }
  },
  extraReducers: (builder) => {
    builder

      .addCase(getCustomerProfileThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerProfileThunk.fulfilled, (state, action) => {
        state.loading = false;
        // state.isLoggedin = true
        state.customer = action.payload;
      })
      .addCase(getCustomerProfileThunk.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(upadteCustomerProfileThunk.pending, (state) => {
        state.basicDetailsLoading = true;
      })
      .addCase(upadteCustomerProfileThunk.fulfilled, (state, action) => {
        state.basicDetailsLoading = false;

      })
      .addCase(upadteCustomerProfileThunk.rejected, (state, action) => {
        state.basicDetailsLoading = false;
      })


      //pass
      .addCase(upadteCustomerPassThunk.pending, (state) => {
        state.Passwordloading = true;
      })
      .addCase(upadteCustomerPassThunk.fulfilled, (state, action) => {
        state.Passwordloading = false;

      })
      .addCase(upadteCustomerPassThunk.rejected, (state, action) => {
        state.Passwordloading = false;
      })

      //addcustomer
      .addCase(addCBillingAddressThunk.pending, (state) => {
        state.alter.loading = true;
      })
      .addCase(addCBillingAddressThunk.fulfilled, (state, action) => {
        state.alter.loading = false;

      })
      .addCase(addCBillingAddressThunk.rejected, (state, action) => {
        state.alter.loading = false;
      })

      //update 
      .addCase(upadteBillingAddressThunk.pending, (state) => {
        state.alter.loading = true;
      })
      .addCase(upadteBillingAddressThunk.fulfilled, (state, action) => {
        state.alter.loading = false;

      })
      .addCase(upadteBillingAddressThunk.rejected, (state, action) => {
        state.alter.loading = false;
      })


      //addShipping
      .addCase(addCShippingAddressThunk.pending, (state) => {
        state.alter.loading = true;
      })
      .addCase(addCShippingAddressThunk.fulfilled, (state, action) => {
        state.alter.loading = false;

      })
      .addCase(addCShippingAddressThunk.rejected, (state, action) => {
        state.alter.loading = false;
      })

      //update 
      .addCase(upadteCShippingAddressThunk.pending, (state) => {
        state.alter.loading = true;
      })
      .addCase(upadteCShippingAddressThunk.fulfilled, (state, action) => {
        state.alter.loading = false;

      })
      .addCase(upadteCShippingAddressThunk.rejected, (state, action) => {
        state.alter.loading = false;
      })
  },
});

export const { setCustomerData, setCustomerEditData, setCustomerRefresh, removeCustomerData, setLoggedIn,setAddress,setLoginpopup,deleteCustomerdata } = customerSlice.actions;

export default customerSlice.reducer;
